<template>
  <div class="container" v-if="salesData">
    <div class="row">
      <div class="col-12">
        <div class="jumbotron jumbotron-img-overlay mb-0 p-0">
          <img src="./../assets/img/cycle-hero.jpg" alt="Paul Smith Men's Suits">
          <div class="jumbotron-img-overlay-wrapper row">
            <div
              class="col-12 col-lg-7 offset-0 offset-lg-5 d-flex flex-column justify-content-center text-center"
            >
              <p class="sub-title m-0 mb-2">{{ view.charAt(0).toUpperCase() + view.slice(1) }} Total</p>
              <p class="m-0 mb-2">{{ moment(date, momentFormat) }}</p>
              <h1 class="header">
                £{{ addCommasToInteger(roundCurrency(salesData.totals[currentTimePeriod].total_sales)) }}
              </h1>
              <p class="m-0 mt-2">
                {{ previousTimePeriod.charAt(0).toUpperCase() + previousTimePeriod.slice(1) }}: £{{
                  addCommasToInteger(roundCurrency(salesData.totals[previousTimePeriod + 's'].total_sales))
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-spacer">
      <div class="col-6 text-center">
        <h2 class="subheader">
          {{ addCommasToInteger(salesData.totals[currentTimePeriod].total_orders) }}
        </h2>
        <p>Orders Placed</p>
      </div>

      <div class="col-6 text-center">
        <h2 class="subheader">
          {{ addCommasToInteger(roundInteger(salesData.totals[currentTimePeriod].total_items)) }}
        </h2>
        <p>Items Sold</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Main",
  data() {
    return {
      date: new Date()
    };
  },
  props: {
    view: String,
    momentFormat: String,
    salesData: Object,
    currentTimePeriod: String,
    previousTimePeriod: String
  }
};
</script>

<style lang="scss">
.header {
  font-size: 2rem;
  letter-spacing: 3px;
  font-weight: 700;
  margin: 0;
}

.subheader {
  font-size: 1.5rem;
}

.sub-title {
  font-size: 1rem;
}

@media (max-width: 1199px) {
  .jumbotron {
    background: #F8F8F8;
    height: 300px;

    img {
      display: none;
    }
  }
}

@media (min-width: 576px) {
  .header {
    font-size: 3.75rem;
  }

  .subheader {
    font-size: 2.5rem;
  }

  .sub-title {
    font-size: 1.125rem;
  }
}
</style>
